var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.574,
    height: 20,
    viewBox: "0 0 13.574 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-pin",
    d: "m19.689 17.64-6.675-3.854a1.712 1.712 0 1 0-1.714 2.965l6.674 3.854a1.713 1.713 0 0 0 1.714-2.966zm-5.505-4.167 5.192 3 1.766-4.914-3.586-2.073-3.373 3.986zM10.356 26.1l4.967-6.033-2.223-1.288-2.744 7.321zM23.287 8.838l-4.449-2.569a1.285 1.285 0 0 0-1.285 2.225L22 11.063a1.284 1.284 0 1 0 1.284-2.225z",
    transform: "translate(-10.356 -6.096)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWhite);
export default __webpack_public_path__ + "static/media/pin-white.96bf0b7ed1f187c18ed141a08cfed56d.svg";
export { ForwardRef as ReactComponent };